import { render, staticRenderFns } from "./NodeView.vue?vue&type=template&id=07c70f17&scoped=true&"
import script from "./NodeView.vue?vue&type=script&lang=js&"
export * from "./NodeView.vue?vue&type=script&lang=js&"
import style0 from "./NodeView.vue?vue&type=style&index=0&id=07c70f17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c70f17",
  null
  
)

export default component.exports